import base from "../../baseurl";
import token from "../../getTk";

const Create = async (blogpostUuid) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("indets/show", {
      json: { blogpostUuid },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
